export const BeautyProfile = {
  beautyprofile: {
    url: "/beautyprofile",
    method: ["GET"]
  },
  beautyProfileCreate: {
    url: "/beautyprofile/create",
    method: ["POST"]
  }
};
